import React, { useState } from "react";
import { Toast } from "utils/toast";

// Shown once. The account can be recovered with any one of these if the phone
// is lost, so the person has to say they have kept them.
const RecoveryCodes = ({ codes, onContinue, continueLabel = "Continue" }) => {
  const [saved, setSaved] = useState(false);
  const text = codes.join("\n");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      Toast("success", "Recovery codes copied.");
    } catch (e) {
      Toast("error", "Couldn't copy. Select the codes and copy them by hand.");
    }
  };

  const download = () => {
    const blob = new Blob(
      [`Routes Control Centre recovery codes\nEach code works once.\n\n${text}\n`],
      { type: "text/plain" }
    );
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "routes-recovery-codes.txt";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="mfa-card">
      <p className="mfa-lead">
        Keep these recovery codes somewhere safe. If you lose your phone, each
        code lets you sign in once. They won't be shown again.
      </p>
      <div className="mfa-codes">
        {codes.map((c) => (
          <span key={c}>{c}</span>
        ))}
      </div>
      <div className="mfa-actions" style={{ marginTop: 0 }}>
        <button type="button" className="mfa-secondary-btn" onClick={copy}>
          Copy
        </button>
        <button type="button" className="mfa-secondary-btn" onClick={download}>
          Download
        </button>
      </div>
      <label style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 16, fontSize: 15 }}>
        <input
          type="checkbox"
          checked={saved}
          onChange={(e) => setSaved(e.target.checked)}
        />
        I've saved these codes
      </label>
      <div className="mfa-actions">
        <button
          type="button"
          className="mfa-primary-btn"
          disabled={!saved}
          onClick={onContinue}
        >
          {continueLabel}
        </button>
      </div>
    </div>
  );
};

export default RecoveryCodes;
